<template>
  <div class="flex flex-col space-y-6">
    <div class="flex justify-between w-full">
      <div v-if="!hideSelectAll">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="isAllChecked"
          @change="handleCheckAll"
        >
          <span :style="estilo">{{labelSelectAll}}</span>
        </el-checkbox>
      </div>
      <div
        v-if="!hideOpenClose"
        @click="changeStateShow()"
        style="cursor: pointer"
      >
        <span v-show="isOpen">
          <i class="fa fa-minus"></i>
        </span>
        <span v-show="!isOpen">
          <i class="fa fa-plus"></i>
        </span>
      </div>
    </div>
    <div>
      <transition name="fade">
        <el-checkbox-group
          v-show="isOpen"
          @change="handleCheckedChange"
          v-model="selecteds"
          class="overflow-auto max-h-80"
        >
          <div
            class="grid gap-4"
            :class="classColItem"
          >
            <div
              v-for="item in items"
              :key="item[idValue] || item"
            >
              <el-checkbox
                :label="item[idValue] || item"
                :key="item[idValue] || item"
              >
                <span :style="estilo">{{ item[labelValue] || item}}</span>
              </el-checkbox>
            </div>
          </div>
        </el-checkbox-group>
      </transition>

    </div>

  </div>
</template>

<script>
export default {
  name: "CheckGroup",
  props: {
    isInitialOpen: { type: Boolean, default: false },
    items: Array,
    value: {
      default: function () {
        return []
      },
      type: Array
    },
    labelValue: String,
    idValue: { type: String, default: "id" },
    hideSelectAll: { type: Boolean, default: false },
    hideOpenClose: { type: Boolean, default: false },
    estilo: Object,
    classColItem: { type: String, default: "md:grid-cols-3 grid-cols-1" },
    labelSelectAll: { type: String, default: "Selecionar Todos" },

  },
  data() {
    return {
      isOpen: this.isInitialOpen,
      selecteds: this.value,
      isAllChecked: false
    };
  },
  methods: {
    handleCheckAll(isChecked) {
      this.selecteds = isChecked ? this.items.map(item => (this.idValue ? item[this.idValue] : item)) : [];
      this.$emit("input", this.selecteds);
      this.validaCheckAll()
    },
    handleCheckedChange(selecteds) {
      this.$emit("input", selecteds);
      this.validaCheckAll()
    },
    changeStateShow() {
      this.isOpen = !this.isOpen;
    },
    validaCheckAll() {
      this.isAllChecked = this.selecteds.length === this.items.length;
    }
  },
  computed: {
    iconStateStyle() {
      return {
        'fa fa-minus': this.isOpen,
        'fa fa-plus': !this.isOpen,
      }
    },
    isIndeterminate() {
      return this.selecteds.length > 0 && this.selecteds.length !== this.items.length;
    }
  },
  created() {
    this.selecteds = this.items.filter(item => this.selecteds.includes(item.id)).map(item => item.id);
    this.validaCheckAll();
  }
};
</script>

<style scoped>
</style>
